var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('div',{staticClass:"preview"},[_c('img',{ref:"image",attrs:{"src":_vm.source,"crossorigin":"anonymous","alt":"anonymous"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }